
__webpack_require__.remotesLoadingData = { chunkMapping: {"8318":["77789"]}, moduleIdToRemoteDataMapping: {"77789":{"shareScope":"default","name":"./App","externalModuleId":33979,"remoteName":"accProjectList"}} };
__webpack_require__.f.remotes = __webpack_require__.f.remotes || function() { throw new Error("should have __webpack_require__.f.remotes"); }
